<template>
  <!-- 选择题题目 -->
  <div class="single-question">
    <single-title
      :num="snum"
      :title="ssubject.subject"
      :ofrom="ohtml"
    ></single-title>
    <!-- 点击事件 -->
    <single-selector
      ref="sinselectRef"
      :num="snum"
      @selected="showResult"
      v-for="(item, index) in ssubject.soptionsArr"
      :key="index"
      :rightResult="ssubject.rightResult"
      :stitle="item"
      :stitleNum="index"
      :canClick="canClick"
    ></single-selector>
  </div>
</template>

<script>
import SingleTitle from "@/components/SingleTitle/SingleTitle";
import SingleSelector from "@/components/SingleSelector/SingleSelector";
import { mapMutations, mapGetters } from "vuex";
import { Message } from "element-ui";

// 测试导入
import { isDone, dealUrl, dealMainTable, ifAllRight } from "@/libs/tools";
export default {
  name: "SingleQuestion",
  props: {
    ssubject: {
      type: Object,
      required: true,
      default: () => {}
    },
    snum: {
      type: Number,
      required: true,
    }, // message
  },
  data() {
    return {
      canClick: true,
      ohtml: "nohtml",
    };
  },
  computed: {
    ...mapGetters({
      getAllsubjectList: "getAllsubjectList",
      allScores: "getAllScore",
      resultList: "getResultList"
    }),
  },
  methods: {
    ...mapMutations({
      updateScore: "updateSubject",
    }),
    isRight() {
      let selectedList = this.getAllsubjectList[this.snum].list
      let result = this.getAllsubjectList[this.snum].rightResult
      console.log(selectedList)
      let temp = result.every(function(item) {
        return selectedList.includes(item)
      })
      console.log(temp)
      return temp
    },
    showResult(value, onum) {
      let result = this.isRight()
      this.storeResult(result)
      let getAllsubjectList = this.getAllsubjectList;
      let acs = getAllsubjectList.every(function (sjg) {
        // 遍历数组
        return sjg.result === true;
      });
      if (acs === true) {
        this.$refs.sinselectRef[onum].hide();
        // 文本提示
        setTimeout(() => {
          this.$tips.info({
            type: "info",
            duration: 0.6,
            content: "您已全部回答正确 请点击提交 !",
            canClick: false,
          });
          // 2 注释后显示最后一道题目
          this.$parent.ifnext = false;
          this.$parent.ifon = false;
        }, 801);
        this.$parent.ifon = false;
        this.$parent.ifnext = false;
        this.$parent.ifsubmit = true;
      }
      if (result) {
        console.log(result)
        this.$refs.sinselectRef[onum].show();
        setTimeout(() => {
          this.$parent.ifnext = true;
          this.$parent.ifon = true;
          if (this.$parent.currentIndex < this.$parent.msubjects.length - 1) {
            this.$parent.currentIndex++;
          }
        }, 800);
      } else {
        this.$refs.sinselectRef[onum].show();
        Message.closeAll();
        if(!value) {
          this.$tips.info({
            type: "info",
            content: "您的回答错误,请重新答题!",
            duration: 0.6,
            canClick: false,
          });
        }
        return;
      }
      this.canClick = false; // 禁止点击
    },
    repeatShow(objArr) {
      objArr.forEach((element) => {
        element.show();
      });
    },
    storeResult(rsu) {
      this.updateScore({
        whichSub: this.snum,
        clicked: true,
        result: rsu,
      });
    },
    // submitResultInfo
  },
  mounted() {
    // console.log('====ssubject', this.ssubject);
    // console.log('====snum', this.snum, typeof this.snum);
  },
  components: {
    SingleTitle,
    SingleSelector,
  },
};
</script>
<style lang="scss" scoped>
@import "~@/common/scss/const.scss";
@import "~@/common/scss/mixin.scss";

.single-question {
  @include box-sizing(content-box);
  background: $color-background-w;
  border-radius: 4px;
  margin-top: pxToRem(15);
  font-size: 14px;
  line-height: 20px;
  &:first-child {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SingleQuestion/SingleQuestion.vue